import { capitalize } from 'lodash-es';
import StyledLastLoggedInWith, {
  StyledCheckedProvider,
  StyledText,
  StyledTooltipWrapper,
} from './LastLoggedInWith.style';
import checkmark from '../../../../images/icons/checkmark.png';

const LastLoggedInWith = ({ provider, lastLoggedInProviderName }) => {
  return lastLoggedInProviderName === provider.authIdentity.toLowerCase() ? (
    <StyledLastLoggedInWith
      title={
        <StyledTooltipWrapper>
          <StyledText>
            you previously signed in with {capitalize(provider.title)}
          </StyledText>
        </StyledTooltipWrapper>
      }
    >
      <StyledCheckedProvider src={checkmark} alt='last logged in provider' />
    </StyledLastLoggedInWith>
  ) : null;
};
export default LastLoggedInWith;
